import { findTask } from "routes/schedule/compare/find-task.js"

export function findAuthoringTask(tasks, task) {
    const list = Array.isArray(tasks) ? tasks : Object.values(tasks ?? {})
    if (task?.isHeader && task?.headerTaskId) {
        const byHeaderTaskId = list.find(
            (candidate) =>
                candidate?.headerTaskId != null && String(candidate.headerTaskId) === String(task.headerTaskId)
        )
        if (byHeaderTaskId) return byHeaderTaskId
    }

    return findTask(list, task)
}

export function normalizeAuthoringTask(task) {
    if (!task?.isHeader) return task

    const headerTaskId = task?.headerTaskId ?? task?.taskId ?? task?.id ?? null
    if (!headerTaskId || task?.taskId === headerTaskId) return task

    return {
        ...task,
        taskId: headerTaskId,
    }
}
